var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTownhouse = function SvgTownhouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5 0 2.656 2.566V1.283h1.328v2.566l.332.32-.692.692L5 1.36.704 5.51 0 4.83 5 0Zm7.143 2.245 3.98 3.884V10H1.02V6.129L5 2.245l3.571 3.486 3.572-3.486ZM6.326 6.122H3.674v3.266h2.652V6.122Zm7.143 0h-2.653v3.266h2.653V6.122ZM12.143 0l2.656 2.566V1.283h1.328v2.566l1.016.981-.704.68-4.296-4.15-3.515 3.496-.168-.213.277-.278-.547-.547L12.143 0Z",
    fill: "#fff"
  })));
};
export default SvgTownhouse;